module.exports = __webpack_public_path__ + "static/media/LocationWhite.svg";